import Vue from 'vue'
import Router from 'vue-router'

import Scoring from '../components/Scoring'
import Result from '../components/Result'

Vue.use(Router)

let customRouter = new Router({
  routes: [

    {
      path: '/',
      redirect: {name: 'scoring'}
    },
    {
      path: '/scoring',
      name: 'scoring',
      component: Scoring
    },
    {
      path: '/result',
      name: 'result',
      component: Result
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

customRouter.beforeEach((to, from, next) => {
  // let $session = customRouter.app.$session
  next()
})

export default customRouter



// WEBPACK FOOTER //
// ./src/router/index.js